var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.errors),function(error){return _c('div',[_vm._v("[ERROR] "+_vm._s(error))])}),_c(_vm.selectedDemo,{tag:"component",on:{"init":_vm.onInit}}),_c('loading-indicator',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }